import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  /** @type {MutationObserver | undefined} */
  #mediaObserver;

  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #formatTimer;

  connectedCallback() {
    super.connectedCallback();
    this.#formatContent();
    this.#mediaObserver = new MutationObserver(() => {
      clearTimeout(this.#formatTimer);
      this.#formatTimer = setTimeout(() => this.#formatContent(), 0);
    });
    this.#mediaObserver.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#formatTimer);
    this.#mediaObserver?.disconnect();
  }

  #formatContent() {
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('iframe, video, .wistia_responsive_padding, .wistia_embed').forEach(this.#formatMedia);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    if (table.parentElement?.classList.contains('rte-table-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  /**
   * Wraps embedded media so it stays within the content container
   * @param {HTMLElement} media
   */
  #formatMedia(media) {
    if (media.closest('.rte-media-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-media-wrapper');
    const parent = media.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, media);
      wrapper.appendChild(media);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
